module.exports = __webpack_public_path__ + "static/blogSpeakIllustration-2685c4e5b6348d0c53b88872a65664c6.svg";